var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "top" }, [
    _c("div", { staticClass: "exam_subject" }, [
      _c("span", [
        _vm._v(
          _vm._s(
            this.$route.query.paperName +
              "(" +
              this.$route.query.paperScore +
              "分" +
              "/" +
              this.$route.query.count +
              "题" +
              ")"
          )
        )
      ])
    ]),
    _vm._v(" "),
    !_vm.userType
      ? _c("div", { staticClass: "exam_time" }, [
          _vm.isTime !== "none"
            ? _c("b", { staticClass: "downTime" }, [
                _vm._v(_vm._s(_vm.countDown))
              ])
            : _vm._e(),
          _vm._v(" "),
          this.showBack
            ? _c(
                "span",
                {
                  staticStyle: {
                    background: "white",
                    color: "rgba(131,182,255,1)",
                    "border-color": "white"
                  },
                  on: { click: _vm.back }
                },
                [_vm._v("返回")]
              )
            : _vm._e(),
          _vm._v(" "),
          !this.showBack
            ? _c("span", { on: { click: _vm.submitTest } }, [_vm._v("交卷")])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ba599fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ba599fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testComponent/header.vue
// module id = null
// module chunks = 